import * as React from 'react'
import { getFormattedDate } from '@shopping/common'
import { scriptLoader, scriptDidLoad, ScriptLoaderProps } from '@shopping/ScriptLoader'
import typeChecker from 'common/typeChecker'
import WindowMessages from 'common/constants/windowMessages'
import { isIe9 } from 'common/utils/oldIeVersion'

// http://wiki.navercorp.com/pages/viewpage.action?pageId=316638553
@scriptLoader([
  `https://ssl.pstatic.net/static.gn/templates/gnb_utf8.nhn?${getFormattedDate(Date.now(), 'YYYYMMDDHH')}`,
])
export class GnbLogin extends React.PureComponent<ScriptLoaderProps, any> {
  componentDidMount() {
    isIe9() && ((window as any).__disposeGnbLoginMessage__ = this.disposeGnbLoginMessage)
    window.addEventListener('message', this.handleReceiveLoggedInMessage)
  }

  componentWillUnmount() {
    isIe9() && delete (window as any).__disposeGnbLoginMessage__
    window.removeEventListener('message', this.handleReceiveLoggedInMessage)
  }

  handleReceiveLoggedInMessage = async (event: MessageEvent) => {
    if (!event.isTrusted) return
    this.disposeGnbLoginMessage(event.data)
  }

  disposeGnbLoginMessage = async ({ action }) => {
    if (WindowMessages.isLoggedIn(action)) {
      this.showLoginArea()
    }
  }

  componentDidUpdate(prevProps) {
    if (scriptDidLoad(prevProps, this.props)) {
      this.setGnbOption()
      this.showLoginArea()
      window['setGnbRedirectUrls'] = this.setGnbRedirectUrls
    }
  }

  setGnbOption() {
    const href = encodeURIComponent(window.location.href)
    window['gnb_option'] = {
      gnb_service: 'shopping',
      gnb_template: 'gnb_utf8',
      gnb_logout: href,
      gnb_login: href,
      gnb_brightness: 3,
    }
  }

  showLoginArea() {
    if (typeChecker.isFunction(window['getGNB'])) {
      window['getGNB']()
    }
  }

  setGnbRedirectUrls() {
    if (typeChecker.isObject(window['gnb_options'])) {
      const href = encodeURIComponent(window.location.href)
      window['gnb_options'].gnb_login = href
      window['gnb_options'].gnb_logout = href
    }
    if (typeChecker.isFunction(window['reloadGnbVariables'])) window['reloadGnbVariables']()
  }

  render() {
    return <div id="gnb" className="gnb_dark_type2" />
  }
}
